<div [hidden]="(isVisible$ | async) === false">
    <hs-panel-header name="Search" [title]="'PANEL_HEADER.SEARCH' | translateHs"></hs-panel-header>
    <div class="input-group search-panel hs-search-address pt-1 pb-1 d-flex">
        <hs-search-input></hs-search-input>
        <hs-search-results></hs-search-results>
    </div>
</div>